import { HelpRule, LiveViewRow } from './interfaces';

// May Need Help, worked out in the browser from the row and the rules the
// server sends with each snapshot (LiveView::MayNeedHelp.rules), so staff can
// try other thresholds without a deploy.

export interface HelpFlags {
  lowScore: boolean,
  tooLong: boolean,
}

const NOT_FLAGGED: HelpFlags = { lowScore: false, tooLong: false };

type QuestionTimeFields = Pick<LiveViewRow, 'questionTimeSeconds'|'questionTimeAsOf'|'idle'>;

// The tool's active time on the current question at `now`: its last report
// plus the time since, unless the tool has stopped counting for inactivity.
// Null when the student is not on a question.
export const questionTimeAt = (row: QuestionTimeFields, now: Date): number|null => {
  if (row.questionTimeSeconds === null || row.questionTimeSeconds === undefined) { return null; }

  const sinceReport = !row.idle && row.questionTimeAsOf ? Math.max((now.getTime() - new Date(row.questionTimeAsOf).getTime()) / 1000, 0) : 0;
  return Math.floor(row.questionTimeSeconds + sinceReport);
};

export const incorrectCount = (row: Pick<LiveViewRow, 'prompts'>): number => row.prompts.filter(prompt => !prompt.optimal).length;

const lowScore = (row: LiveViewRow, rule: HelpRule): boolean => {
  const failed = incorrectCount(row);
  return failed > 0 && failed >= rule.minFailed;
};

const tooLong = (row: LiveViewRow, rule: HelpRule, now: Date): boolean => {
  const questionTime = questionTimeAt(row, now);
  return questionTime !== null && questionTime >= rule.questionSeconds;
};

export const helpFlags = (row: LiveViewRow, rule: HelpRule|undefined, now: Date): HelpFlags => {
  if (!rule || rule.unflaggedReason || row.onlineOnly || row.redacted) { return NOT_FLAGGED; }

  return { lowScore: lowScore(row, rule), tooLong: tooLong(row, rule, now) };
};
